<template>
    <div class="pagination">
    <button 
      :disabled="currentPage === 1" 
        @click="changePage(currentPage - 1)">
        « Prev
      </button>
  
    <span v-for="page in pageNumbers" :key="page">
      <button 
        :disabled="page === currentPage"
        @click="changePage(page)">
        {{ page }}
      </button>
    </span>
    
    <!-- <span>Page {{ currentPage }} of {{ totalPages }}</span> -->

    <button 
      :disabled="currentPage >= totalPages" 
      @click="changePage(currentPage + 1)">
      Next »
    </button>
  </div>
  </template>
  
  <script>
  export default {
    props: {
      totalRows: {
        type: Number,
        required: true
      },
      itemsPerPage: {
        type: Number,
        required: true
      },
    value: {
        type: Number,
        required: true
      }
    },
  
    computed: {
      totalPages() {
        return Math.ceil(this.totalRows / this.itemsPerPage);
      },
      currentPage: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
    },
    pageNumbers() {
      const pages = [];
      const maxPagesToShow = 5;
      let startPage = Math.max(this.currentPage - Math.floor(maxPagesToShow / 2), 1);
      let endPage = startPage + maxPagesToShow - 1;
  
      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = Math.max(endPage - maxPagesToShow + 1, 1);
        }
      
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },

  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    }
  }
}
  </script>
  
  <style>
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
  }
  
  .pagination button {
  margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
  }
  
  .pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  </style>